import { css } from "@compiled/react";
import { DEFAULT_VALUES } from "@libraries/web-framework";
import { FormattedMessage, useIntl } from "react-intl";

import { media } from "@atlaskit/primitives/responsive";
import { token } from "@atlaskit/tokens";

import { Button } from "../../../../components/wpl/button/src/index";
import { Link } from "../../../../components/wpl/link/src/index";

const backgroundStyles = css({
    flexDirection: "column",
    margin: "auto 16px",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    alignItems: "stretch",
    overflow: "hidden",
    textAlign: "center",
    background: "#9fc365",
    borderRadius: "3px",
    maxWidth: "1440px",
    [media.above.sm]: {
        display: "flex",
        width: "600px",
        margin: "auto",
        flexDirection: "row",
        gap: "unset"
    },
    [media.above.md]: {
        width: "unset",
        margin: "auto 16px",
        textAlign: "left",
        background: "none",
        borderRadius: 0,
        backgroundImage:
            "url(https://wac-cdn.atlassian.com/misc-assets/webp-images/wac_banner_background_11_14_23.webp)",
        backgroundSize: "100% 100%"
    }
});

const titleImageStyles = css({
    flex: "1 20%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    paddingBlockStart: "34px",
    boxSizing: "border-box",
    [media.below.md]: {
        display: "none"
    },
    [media.above.sm]: {
        padding: `${token("space.400")} ${token("space.200")} ${token(
            "space.200"
        )} ${token("space.200")}`
    },
    img: {
        maxWidth: "100%",
        height: "70px"
    }
});

const descriptionStyles = css({
    display: "flex",
    flex: "1 75%",
    flexDirection: "column",
    alignItems: "center",
    paddingBlockEnd: "22px",
    paddingInlineStart: "16px",
    paddingInlineEnd: "16px",
    paddingBlockStart: "22px",
    boxSizing: "border-box",
    gap: "24px",
    [media.above.sm]: {
        gap: 0
    },
    [media.above.md]: {
        flexDirection: "row",
        paddingBlockEnd: 0,
        flex: "1 58.33333%"
    }
});

const descriptionTextColumnStyles = css({
    flex: "1 100%",
    boxSizing: "border-box",
    color: "#000000",
    [media.above.sm]: {
        paddingBlockEnd: "22px",
        paddingBlockStart: "16px"
    }
});

const descriptionButtonStyles = css({
    flex: "1 0%",
    boxSizing: "border-box",
    fontWeight: 500,
    [media.above.sm]: {
        paddingInlineStart: "16px"
    }
});

const locationStyles = css({
    flex: "1 16.66666%",
    padding: `0 ${token("space.200")} 0 ${token("space.200")}`,
    boxSizing: "border-box",
    display: "flex",
    alignItems: "flex-end",
    img: {
        verticalAlign: "bottom",
        width: "100%"
    },
    [media.below.md]: {
        display: "none"
    }
});

export const UnleashBanner = () => {
    const intl = useIntl();
    const description = (
        <FormattedMessage
            id="LiftedBar.Unleash.description"
            defaultMessage={`Time is running out to get your free ticket for Atlassian Presents: Unleash using code <strong>ULLASTCHANCECOMP101</strong>! Learn how to solve the challenges your teams face with the tools your teams love.`}
            values={DEFAULT_VALUES}
        />
    );
    const ctaText = intl.formatMessage({
        id: "LiftedBar.Unleash.cta",
        defaultMessage: "Register now"
    });
    const ctaUrl =
        "https://events.atlassian.com/unleash?ref=Unleash&utm_source=marketing&utm_campaign=acquisitionwebliftedbar&utm_medium=web";

    return (
        <div css={backgroundStyles}>
            <div css={titleImageStyles}>
                <img
                    src="https://wac-cdn.atlassian.com/misc-assets/webp-images/Atlassian_Presents_Unleash_logo_banner.webp"
                    alt={intl.formatMessage({
                        id: "LiftedBar.Unleash.logoAltText",
                        defaultMessage: "Unleash text logo"
                    })}
                />
            </div>
            <div css={descriptionStyles}>
                <div css={descriptionTextColumnStyles}>
                    <p
                        css={css({
                            marginBlockEnd: 0,
                            marginBlockStart: 0
                        })}
                    >
                        {description}
                    </p>
                </div>
                <div css={descriptionButtonStyles}>
                    <Button
                        size={"small"}
                        dataEventProps={{
                            "data-event-component": "linkButton",
                            "data-event-container": "banner-link-button",
                            "data-event": "clicked",
                            "data-product-key": "jiraSoftware"
                        }}
                        url={ctaUrl}
                        css={css({
                            whiteSpace: "nowrap",
                            fontWeight: 500,
                            [media.below.md]: {
                                display: "none"
                            }
                        })}
                        text={ctaText}
                    />
                    <Link
                        text={ctaText}
                        href={ctaUrl}
                        customLinkColor="#164B35"
                        doesArrowAnimate={true}
                        css={css({
                            [media.above.md]: {
                                display: "none"
                            }
                        })}
                    />
                </div>
            </div>
            <div css={locationStyles}>
                <img
                    src="https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_ProductTour_PromoBannerGeo.webp"
                    alt={intl.formatMessage({
                        id: "LiftedBar.Unleash.location.imageAltText",
                        defaultMessage: "St. Nicholas Church in Amsterdam"
                    })}
                />
            </div>
        </div>
    );
};
